export const CONFIG = {
    apiUrl: 'https://api.leadrs.co',
    //apiUrl: 'http://localhost:8080',
};
